<span *ngIf="fileFetching" class="k-icon k-i-loading spinner"></span>

<ng-container *ngTemplateOutlet="isImage ? imageTpl : isPdf ? pdfTpl : unknownFileTpl"></ng-container>

<ng-template #imageTpl>
  <img
    appAnimalEmptyPhoto
    [style.display]="fileFetching ? 'none' : 'inline'"
    class="image"
    draggable="false"
    [alt]="attach.docName"
    [src]="attach.docUrl | resourceUrl"
    (load)="onFileLoad()"
    (error)="onFileLoadError($event)"
  />
</ng-template>

<ng-template #pdfTpl>
  <iframe
    [style.opacity]="fileFetching ? 0 : 1"
    class="iframe"
    [src]="attach.docUrl | resourceUrl"
    (load)="onFileLoad()"
    (error)="onFileLoadError($event)"
  >
  </iframe>
</ng-template>

<ng-template #unknownFileTpl>
  <p class="unknown-file">
    Предварительный просмотр файла в данном окне невозможен, так как файл имеет специализированный формат
    <ng-container *ngIf="file.extension"> ({{ file.extension }}) </ng-container>
    <span class="notification-download" *ngIf="downloadingIsActive; else downloadTpl">(идет скачивание файла...)</span>
    <ng-template #downloadTpl>
      <a class="download-link" (click)="downloadFile()">(скачать)</a>
    </ng-template>
  </p>
</ng-template>
